import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outterContainer: {
            flexDirection: 'column',
            gap: remCalc(24),
        },
        container: {
            gap: remCalc(16),
            flexDirection: 'column',
            textStyle: 'body-small',
            pY: 'space.xxsmall',
        },
        header: {
            gap: remCalc(16),
            flexDirection: 'column',
        },
        title: {
            fontWeight: 'bold',
            textStyle: 'body-small',
            color: 'text.default',
        },
        description: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'text.default',
        },
        warrantiesContainer: {
            flexDirection: 'column',
            gap: remCalc(16),
            paddingY: remCalc(8),
        },
        radioContainer: {
            alignItems: {base: 'flex-start', md: 'center'},
            flexDirection: {base: 'column', md: 'row'},
        },
        itemContainer: {
            as: 'span',
            alignItems: {base: 'flex-start', md: 'center'},
            gap: remCalc(5),
            position: 'relative',
            top: remCalc(2),
            textStyle: 'body-small',
            color: 'text.default',
            flexDirection: {base: 'column', md: 'row'},
        },
        price: {
            as: 'span',
            fontWeight: 'bold',
            textStyle: 'body-small',
            color: 'text.default',
            display: {base: 'block', md: 'inline'},
        },
        termsAndConditionsContainer: {
            flexDirection: 'row',
            flex: 'flex-start',
            textStyle: 'body-xsmall',
            color: 'text.default',
        },
        termsAndConditionsLink: {},
    },
}
